import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import createPersistedState from "vuex-persistedstate";
import crypto from '@/util/toolClass/crypto'
import config from './modules/config/index.js'
const vuexStorage = createPersistedState({
    // reducer: data => {
    //     return {
    //         userInfo: md5(JSON.stringify(data.userInfo))
    //     }
    // },
    // key:'vuex',
    storage: {
        getItem: key => {
            let data = localStorage.getItem(key);
            return data ? JSON.parse(crypto.decrypt(data)) : data
        },
        setItem: (key, value) => {
            let data = value ? crypto.encrypt(value) : value;
            localStorage.setItem(key, data)
        },
        removeItem: key => {
            localStorage.removeItem(key)
        }
    }
})
Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        language: 'en',
        ischooseAdv:false,
        userInfo: '',
        user_role_new:{},
        widther_Show:false,
        extArr:[],
        band_width:1,
        routerLimitMap:[],
        routerLimitObj:{}
        // language: 'zh_cn'
    },
    getters: {},
    mutations: mutations,
    actions: actions,
    modules: {
        config
    },
    strict: process.env.NODE_ENV !== 'production',
    plugins: [vuexStorage]
})

export default store;


// WEBPACK FOOTER //
// ./src/stores/index.js